(() => {
  const dialog = document.querySelector('[data-withdrawal-dialog]');
  if (!(dialog instanceof HTMLDialogElement)) return;

  const form = dialog.querySelector('.as-withdrawal-form');
  if (!(form instanceof HTMLFormElement)) return;

  const frame = dialog.querySelector('.as-withdrawal-dialog__frame');
  const steps = Array.from(dialog.querySelectorAll('[data-withdrawal-step]'));
  const formStep = dialog.querySelector('[data-withdrawal-step="form"]');
  const reviewStep = dialog.querySelector('[data-withdrawal-step="review"]');
  const successStep = dialog.querySelector('[data-withdrawal-step="success"]');
  const summary = dialog.querySelector('[data-withdrawal-summary]');
  const timestampInput = dialog.querySelector('[data-withdrawal-timestamp]');
  const bodyInput = dialog.querySelector('[data-withdrawal-body]');
  const receiptOrder = dialog.querySelector('[data-withdrawal-receipt-order]');
  const receiptTime = dialog.querySelector('[data-withdrawal-receipt-time]');
  const storageKey = 'sucaroma_withdrawal_receipt';
  let lastTrigger = null;
  let confirmed = false;

  const field = (selector) => {
    const element = form.querySelector(selector);
    return element instanceof HTMLInputElement || element instanceof HTMLSelectElement || element instanceof HTMLTextAreaElement
      ? element.value.trim()
      : '';
  };

  const values = () => ({
    name: field('#WithdrawalName'),
    order: field('#WithdrawalOrder'),
    email: field('#WithdrawalEmail'),
    scope: field('#WithdrawalScope'),
    received: field('#WithdrawalReceived'),
    products: field('#WithdrawalProducts'),
    notes: field('#WithdrawalNotes'),
  });

  const showStep = (target) => {
    steps.forEach((step) => {
      step.hidden = step !== target;
    });
    if (frame instanceof HTMLElement) frame.scrollTop = 0;
  };

  const openDialog = () => {
    lastTrigger = document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('as-withdrawal-open');
    if (successStep && !successStep.hidden) return;
    showStep(formStep);
    window.setTimeout(() => form.querySelector('input:not([type="hidden"])')?.focus(), 40);
  };

  const closeDialog = () => {
    if (dialog.open) dialog.close();
    document.body.classList.remove('as-withdrawal-open');
    if (lastTrigger instanceof HTMLElement) lastTrigger.focus();
  };

  const addSummaryRow = (label, value) => {
    if (!summary || !value) return;
    const row = document.createElement('div');
    const term = document.createElement('dt');
    const detail = document.createElement('dd');
    term.textContent = label;
    detail.textContent = value;
    row.append(term, detail);
    summary.append(row);
  };

  const prepareReview = () => {
    if (!form.reportValidity()) return false;
    const data = values();
    if (!summary) return false;
    summary.replaceChildren();
    addSummaryRow('Nume', data.name);
    addSummaryRow('Comandă', data.order);
    addSummaryRow('Email confirmare', data.email);
    addSummaryRow('Retragere', data.scope);
    addSummaryRow('Data primirii', data.received || 'Necompletată');
    addSummaryRow('Produse vizate', data.products || (data.scope === 'Comanda integrală' ? 'Toate produsele din comandă' : 'Nespecificate'));
    addSummaryRow('Alte detalii', data.notes || '—');
    confirmed = false;
    showStep(reviewStep);
    reviewStep?.querySelector('h3')?.focus?.();
    return true;
  };

  const buildReceipt = () => {
    const data = values();
    const now = new Date();
    const localTime = new Intl.DateTimeFormat('ro-RO', {
      timeZone: 'Europe/Bucharest',
      dateStyle: 'full',
      timeStyle: 'medium',
    }).format(now);
    const timestamp = `${now.toISOString()} / ${localTime} (Europe/Bucharest)`;

    if (timestampInput instanceof HTMLInputElement) timestampInput.value = timestamp;
    if (bodyInput instanceof HTMLTextAreaElement) {
      bodyInput.value = [
        'DECLARAȚIE NEECHIVOCĂ DE RETRAGERE DIN CONTRACT',
        `Nume: ${data.name}`,
        `Număr comandă: ${data.order}`,
        `Email: ${data.email}`,
        `Tip retragere: ${data.scope}`,
        `Data primirii produselor: ${data.received || 'necompletată'}`,
        `Produse vizate: ${data.products || (data.scope === 'Comanda integrală' ? 'toate produsele din comandă' : 'nespecificate')}`,
        `Alte detalii: ${data.notes || '—'}`,
        `Data și ora transmiterii: ${timestamp}`,
        '',
        'Consumatorul declară fără echivoc că dorește să se retragă din contractul identificat prin comanda de mai sus.',
      ].join('\n');
    }

    const receipt = { ...data, timestamp, localTime };
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(receipt));
    } catch (_) {
      // The contact form still submits if browser storage is unavailable.
    }
    return receipt;
  };

  const loadReceipt = () => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  };

  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const printReceipt = (receipt) => {
    if (!receipt) return;
    const printWindow = window.open('', 'sucaroma-withdrawal-receipt');
    if (!printWindow) {
      window.alert('Browserul a blocat fereastra de printare. Permite ferestrele pop-up și încearcă din nou.');
      return;
    }
    printWindow.opener = null;
    const products = receipt.products || (receipt.scope === 'Comanda integrală' ? 'Toate produsele din comandă' : 'Nespecificate');
    printWindow.document.open();
    printWindow.document.write(`<!doctype html>
      <html lang="ro">
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <title>Dovadă retragere comandă ${escapeHtml(receipt.order)}</title>
          <style>
            @page { size: A4; margin: 18mm; }
            * { box-sizing: border-box; }
            body { margin: 0; color: #173d29; font: 15px/1.5 Arial, sans-serif; }
            main { max-width: 760px; margin: 0 auto; }
            header { padding-bottom: 20px; border-bottom: 3px solid #34a748; }
            .kicker { margin: 0 0 8px; color: #2b8c40; font-size: 12px; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; }
            h1 { margin: 0; color: #111; font-size: 28px; line-height: 1.15; }
            .meta { margin: 8px 0 0; color: #617166; }
            dl { margin: 24px 0; border: 1px solid #cfdbd0; border-radius: 12px; overflow: hidden; }
            dl div { display: grid; grid-template-columns: 180px 1fr; gap: 16px; padding: 12px 16px; border-bottom: 1px solid #e2e9e2; }
            dl div:last-child { border-bottom: 0; }
            dt { color: #66756b; font-weight: 700; }
            dd { margin: 0; color: #173d29; font-weight: 700; white-space: pre-line; }
            .declaration { padding: 16px; border-radius: 12px; background: #eef7eb; }
            footer { margin-top: 28px; padding-top: 16px; border-top: 1px solid #cfdbd0; color: #617166; font-size: 12px; }
            @media print { .print-note { display: none; } }
          </style>
        </head>
        <body>
          <main>
            <header>
              <p class="kicker">Dovadă locală · Suc aRoma</p>
              <h1>Declarație de retragere din contract</h1>
              <p class="meta">Generată după transmiterea formularului online.</p>
            </header>
            <dl>
              <div><dt>Nume</dt><dd>${escapeHtml(receipt.name)}</dd></div>
              <div><dt>Număr comandă</dt><dd>${escapeHtml(receipt.order)}</dd></div>
              <div><dt>Email</dt><dd>${escapeHtml(receipt.email)}</dd></div>
              <div><dt>Tip retragere</dt><dd>${escapeHtml(receipt.scope)}</dd></div>
              <div><dt>Data primirii</dt><dd>${escapeHtml(receipt.received || 'Necompletată')}</dd></div>
              <div><dt>Produse vizate</dt><dd>${escapeHtml(products)}</dd></div>
              <div><dt>Alte detalii</dt><dd>${escapeHtml(receipt.notes || '—')}</dd></div>
              <div><dt>Data și ora transmiterii</dt><dd>${escapeHtml(receipt.timestamp)}</dd></div>
            </dl>
            <p class="declaration">Consumatorul declară fără echivoc că dorește să se retragă din contractul identificat prin comanda de mai sus.</p>
            <footer>
              <strong>DELICON PRODIMPEX SRL</strong> · CUI RO9288196 · J33/2591/1994<br>
              Str. 9 Mai nr. 4, Fălticeni, jud. Suceava · comenzi@sucaroma.ro
            </footer>
          </main>
        </body>
      </html>`);
    printWindow.document.close();
    printWindow.focus();
    window.setTimeout(() => printWindow.print(), 250);
  };

  const renderSuccess = () => {
    const receipt = loadReceipt();
    if (receiptOrder) receiptOrder.textContent = receipt?.order ? `#${receipt.order.replace(/^#/, '')}` : 'Vezi emailul trimis comerciantului';
    if (receiptTime) receiptTime.textContent = receipt?.localTime || 'Momentul transmiterii';
    showStep(successStep);
    openDialog();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-withdrawal-open]') : null;
    if (trigger) {
      event.preventDefault();
      openDialog();
      return;
    }

    if (event.target instanceof Element && event.target.closest('[data-withdrawal-close]')) {
      event.preventDefault();
      closeDialog();
    }
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  dialog.addEventListener('close', () => {
    document.body.classList.remove('as-withdrawal-open');
  });

  dialog.querySelector('[data-withdrawal-review]')?.addEventListener('click', prepareReview);
  dialog.querySelector('[data-withdrawal-back]')?.addEventListener('click', () => showStep(formStep));
  dialog.querySelector('[data-withdrawal-confirm]')?.addEventListener('click', () => {
    confirmed = true;
  });

  form.addEventListener('submit', (event) => {
    if (!confirmed) {
      event.preventDefault();
      prepareReview();
      return;
    }
    if (!form.reportValidity()) {
      event.preventDefault();
      confirmed = false;
      showStep(formStep);
      return;
    }
    buildReceipt();
  });

  dialog.querySelector('[data-withdrawal-download]')?.addEventListener('click', () => {
    const receipt = loadReceipt();
    if (!receipt) return;
    const content = [
      'DOVADĂ LOCALĂ — DECLARAȚIE DE RETRAGERE DIN CONTRACT',
      'Destinatar: DELICON PRODIMPEX SRL — comenzi@sucaroma.ro',
      `Nume: ${receipt.name}`,
      `Număr comandă: ${receipt.order}`,
      `Email: ${receipt.email}`,
      `Tip retragere: ${receipt.scope}`,
      `Data primirii produselor: ${receipt.received || 'necompletată'}`,
      `Produse vizate: ${receipt.products || (receipt.scope === 'Comanda integrală' ? 'toate produsele din comandă' : 'nespecificate')}`,
      `Alte detalii: ${receipt.notes || '—'}`,
      `Data și ora transmiterii: ${receipt.timestamp}`,
      '',
      'Această dovadă a fost generată în browser la trimiterea formularului.',
    ].join('\n');
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `retragere-comanda-${String(receipt.order).replace(/[^a-z0-9-]/gi, '') || 'sucaroma'}.txt`;
    document.body.append(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  });

  dialog.querySelector('[data-withdrawal-print]')?.addEventListener('click', () => {
    printReceipt(loadReceipt());
  });

  const params = new URLSearchParams(window.location.search);
  if (params.get('retragere_trimisa') === '1') {
    renderSuccess();
    params.delete('retragere_trimisa');
    const query = params.toString();
    history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
  } else if (window.location.hash === '#retragere-din-contract') {
    openDialog();
  }
})();
